import { useSelector } from 'react-redux';

import { isPersonerd } from 'dashboard/redux/selectors/current-user';
import { RootState } from 'dashboard/redux/store';

/**
 * @name `useIsPersonerd`
 *
 * A hook that returns whether the current user is a Persona employee,
 * determined by checking for email domain or impersonation status
 *
 * Not intended for long term usage.
 * Quick convenient interim workaround for restricting features to internal-only.
 *
 */
export default () => {
  return useSelector<RootState, boolean>((state) => isPersonerd(state));
};
